/* global attachEvent */

// *******************************************************************************
// 1.0 - Open dropdown
// *******************************************************************************

window.addEventListener('spectoCmsContentLoaded', () => {
  window.dropdowns = document.querySelectorAll('.dropdown');


// Open dropdown
  injection.attachEvent('.dropdown__placeholder', 'click', (placeholder) => {
    const parent = placeholder.target.closest('.dropdown');
    parent.classList.toggle('is-open');
  });

// Close on click outside
  document.addEventListener('click', (ev) => {
    dropdowns.forEach((dropdown) => {
      const clickInside = dropdown.contains(ev.target);
      if (!clickInside) {
        dropdown.classList.remove('is-open');
      }
    });
  });

// Pick option
  injection.attachEvent('.dropdown__list-option', 'click', (dropdownOption) => {
    const dropdownParent = dropdownOption.target.closest('.dropdown');
    const dropdownPlaceholderText = dropdownParent.querySelector('.dropdown__placeholder-text');

    const dropdownOptionText = dropdownOption.target.innerHTML;
    dropdownPlaceholderText.innerHTML = dropdownOptionText;

    dropdownParent.classList.remove('is-open');
    dropdownParent.classList.add('is-selected');
  });
});
